"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useComboboxContextValues", {
    enumerable: true,
    get: function() {
        return useComboboxContextValues;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useComboboxContextValues(state) {
    const { appearance, open, registerOption, selectedOptions, selectOption, setOpen, size, activeDescendantController, activeOption: UNSAFE_activeOption, setActiveOption: UNSAFE_setActiveOption } = state;
    const combobox = {
        activeOption: UNSAFE_activeOption,
        appearance,
        focusVisible: false,
        open,
        registerOption,
        selectedOptions,
        selectOption,
        setActiveOption: UNSAFE_setActiveOption,
        setOpen,
        size
    };
    const activeDescendant = _react.useMemo(()=>({
            controller: activeDescendantController
        }), [
        activeDescendantController
    ]);
    return {
        combobox,
        activeDescendant
    };
}
